import { MutableRefObject, useEffect, useRef, useState } from 'react';
import {
  zoom as d3zoom,
  interpolateRound as d3interpolateRound,
  ScaleLinear as d3ScaleLinear,
  select as d3select,
} from 'd3';

export interface UseZoomProps {
  svgRef: MutableRefObject<SVGSVGElement | undefined>;
  scaleX: d3ScaleLinear<number, number>;
  scaleY: d3ScaleLinear<number, number>;
  defaultTransform?: { k: number; x: number; y: number };
  size?: any;
  onZoom?: () => void;
}

export const useZoom = ({
  svgRef,
  scaleX,
  scaleY,
  defaultTransform = { k: 1, x: 0, y: 0 },
  size,
  onZoom,
}: UseZoomProps) => {
  const zx = useRef<d3ScaleLinear<number, number>>(scaleX);
  const zy = useRef<d3ScaleLinear<number, number>>(scaleY);
  const [transform, setTransform] = useState(defaultTransform);

  useEffect(() => {
    if (svgRef.current) {
      const zoom = d3zoom()
        .filter((event) => !event.shiftKey)
        .scaleExtent([1 / 2 ** 3, 2 ** 3])
        .on('zoom', (event) => {
          onZoom?.();
          zx.current = event.transform
            .rescaleX(scaleX)
            .interpolate(d3interpolateRound);
          zy.current = event.transform
            .rescaleY(scaleY)
            .interpolate(d3interpolateRound);
          setTransform(event.transform);
        });
      d3select(svgRef.current).call(zoom as any);
    }
  }, [svgRef.current, size]);

  return { transform, scaleX: zx.current, scaleY: zy.current };
};
